angular.module('gym.components').directive('signedWaiverTacs', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      collapsible: '=',
      defaultCollapsed: '='
    },
    template: require('templates/components/waivers/signed_waiver_tacs.html.slim')
  };
});
